import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { LoadingButton } from '@mui/lab';
import { TextField } from '@mui/material';
import { postSolveFailedPayoutSupportCase } from 'src/api/oApi';
import { generalStore } from 'src/stores/GeneralStore';
import { SupportCaseByIdResponse } from 'src/models/supportcaseById';

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function SolveCaseFailedPayoutDialog({
  open,
  setOpen,
  supportCase,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  supportCase?: SupportCaseByIdResponse | null;
}) {
  if (!supportCase) return null;
  const handleClose = () => {
    setOpen(false);
  };

  const [message, setMessage] = React.useState<string | null>(null);
  const [mangopayId, setMangopayId] = React.useState<string | null>(null);
  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Failed Payout Fall lösen</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              Um einen failedPayout Supportfall zu lösen muss zuerst der Payout erfolgt sein. Die neue TransaktionsId vom Payout wird dann
              in das Feld MangopayId eingetragen.
            </div>
            <TextField
              fullWidth
              sx={{ m: 1 }}
              placeholder="Message"
              type="text"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <TextField
              fullWidth
              sx={{ m: 1 }}
              placeholder="MangopayId"
              type="text"
              name="mangopayId"
              value={mangopayId}
              onChange={(e) => setMangopayId(e.target.value)}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={async () => {
              try {
                await postSolveFailedPayoutSupportCase({
                  message: message as string,
                  supportCaseId: supportCase.id,
                  resourceId: mangopayId as string,
                });
                generalStore.setMessage('Successfully Created the Message');
                setOpen(false);
              } catch (error: any) {
                generalStore.setError(error?.response?.data?.error?.message || error?.response?.data?.error);
              }
            }}
            fullWidth
            sx={{ m: 1 }}
            color="primary"
            variant="contained"
          >
            FailedPayout Fall lösen
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
